//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

/**
 * Takes a string and encodes all html characters to escaped values
 *
 * @param text The input text to encode
 */
export function htmlEncode(text: string): string {
  return $('<div/>').text(text).html();
}
